<template>
    <MainContent title="Editar comunicado">
        <template v-slot:header>
            <h3 class="card-title pb-3">Editar comunicado</h3>
        </template>
        <template v-slot:content>
            <div class="row" v-if="!loading">
                <div class="col-12">
                    <FormComunicado v-if="comunicado" :comunicado="comunicado" @terminado="editarComunicado"></FormComunicado>
                </div>
            </div>
        </template>
    </MainContent>
</template>

<script>
import MainContent from "@/components/backend/components/MainContent";
import FormComunicado from '@/components/backend/comunicados/FormComunicado';

export default {   
    props: ['comunicado_id'], 
    data() {
        return {
            comunicado: null,
            loading: false,
            conf: {}
        }
    },
    methods: {
        getComunicado() {
            this.loading = true;

            const data = {
                filters: {},
                comunicado_id: this.comunicado_id
            };

            this.$store.dispatch(this.config.getVuexAlias('back.comunicados.show'), data).then(res => {
                this.comunicado = res.data.data;
            }).finally(() => this.loading = false);
        },
        async submit() {
            const isValid = await this.$refs.observer.validate();
            if(isValid) {
                this.editarComunicado();
            }
        },
        editarComunicado() {
            this.loading = true;

            this.comunicado.filters = {};
            this.comunicado.comunicado_id = this.comunicado_id;
            this.comunicado.evento_id ? this.comunicado.evento_id = this.comunicado.evento_id.id : this.comunicado.evento_id = null;

            if (this.comunicado.tipo === 2) {
                delete this.comunicado.titulo, delete this.comunicado.contenido;
            }

            this.$store.dispatch(this.config.getVuexAlias('back.comunicados.editar'), this.comunicado).then(res => {
                this.$toast.success(res.data.message);
                this.$router.push({ name: 'back.comunicados.index', query: { tipo: this.comunicado.tipo }});
            }).finally(() => this.loading = false);
        }
    },
    created() {
        this.getComunicado();
    },
    components: {
        MainContent, FormComunicado
    }
}
</script>
